import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/superbuy-spreadsheet-ultimate-guide/page";
import SneakerheadsArticle from "@/pages/article/superbuy-spreadsheet-for-sneakerheads/page";
import QCPhotosArticle from "@/pages/article/track-qc-photos-superbuy-sheet/page";
import BudgetArticle from "@/pages/article/superbuy-spreadsheet-pricing-budget-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/superbuy-spreadsheet-ultimate-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/superbuy-spreadsheet-for-sneakerheads",
    element: <SneakerheadsArticle />,
  },
  {
    path: "/article/track-qc-photos-superbuy-sheet",
    element: <QCPhotosArticle />,
  },
  {
    path: "/article/superbuy-spreadsheet-pricing-budget-guide",
    element: <BudgetArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;